<style lang="scss" scoped>
.fd-content {
  height: 100%;
  width: 100%;
  p {
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 5px;
    line-height: 21px;
  }
  .data-chart {
    width: 100%;
    height: 80%;
    .data-img {
      width: 100%;
      height: 60%;
      border: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      .imgs {
        width: 49%;
        height: 42%;
      }
    }
  }

  .chart-img {
    margin-top: 5%;
    width: 100%;
    height:20%;
  }
  .chart-content {
    height: 80%;
  }
}
</style>

<template>
  <div class="fd-content">
    <p>{{title}}历史数据({{ map[timer] }})</p>
    <div class="data-chart" v-if="!dataList.y.length">
      <div class="data-img">
        <img src="@/assets/cut/data-img.png" alt="" class="imgs" />
      </div>
      <div class="chart-img">
        <chart-base :options="option"></chart-base>
      </div>
    </div>
    <div class="chart-content" v-else>
      <chart-base :options="option"></chart-base>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-charts",
  props: {
    timer: {
      type: String,
      default: "day",
    },
    title:{
      type:String,
      default:''
    },
    dataList: {
      type: Object,

    },
  },
  watch: {
    dataList() {
      this.loadOption();
    },
  },
  created() {
    this.loadOption();
  },
  methods: {
    loadOption() {
      if (this.dataList?.x?.length == 0 && this.dataList?.y?.length == 0) {
        for (var i = 1; i < 25; i++) {
          this.dataList.x.push(i);
        }
      }
      this.option = {
        // backgroundColor: "rgba(14,18,29,0.80)", //背景色
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        //提示框
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "#13171F",
          borderColor: "#13171F",
          padding: [12, 17, 20, 23],
          textStyle: { color: "#fff" },
          renderMode: "html",
          className: "tooltip",
        },
        legend: {
          type: "plain",
          right: 44,
          top: 45,
          bottom: 12,
          itemGap: 64,
          itemWidth: 10,
          icon: "circle",
          // padding: [10, 0, 0, 0],
          //图例滚动
          // type: 'scroll',
          //图例文字样式
          textStyle: {
            color: "#FFFFFF",
            fontSize: "15",
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            interval: 0,
            //  boundaryGap: false,
            axisLabel: {
              margin: 8,
              textStyle: {
                color: "#ADAB9D",
              },

              fontSize: "15",
            },
            axisLine: {
              show: false,
            },
            data: this.dataList.x, //日期
          },
        ],
        yAxis: [
          {
            // offset: -25,
            type: "value",
            name: "",
            min: 0,
            axisLabel: {
              formatter: "{value} ",
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              textStyle: {
                //坐标轴颜色
                color: "#EFEFEB",
                fontSize: "16px",
              },
            },
            //坐标轴线样式
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed", //solid实线;dashed虚线
                color: "#D3D3D3",
                opacity: 0.15,
              },
            },
          },
        ],
        series: [
          {
            symbol: "none", //去掉折线上的小点
            // name: "昨日曲线",
            data: this.dataList.y,
            type: "line",
            smooth: true, //true曲线; false折线
            itemStyle: {
              normal: {
                color: "rgba(79, 154, 255, 1)", //改变折线点的颜色
                lineStyle: {
                  color: "rgba(27, 154, 255, 1)", //改变折线颜色
                  type: "solid",
                },
              },
            },
            areaStyle: {
              //折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(27, 154, 255, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(27, 154, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          //    {
          //     name: '',
          //     type: 'line',
          //     showAllSymbol: true,
          //     symbol: 'none',
          //     itemStyle: {
          //         color: 'red',
          //     },
          //     lineStyle: {
          //         width: 1,
          //         type: 'dotted',
          //         color: 'red',
          //         shadowColor: '#FFF500',
          //         shadowBlur: 10,
          //     },
          //     data: [35000, 35000,35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000],
          // },
        ],
      };
    },
  },
  data() {
    return {
      option: {},
      map: {
        day: "24小时",
        month: "30天",
        year: "12个月",
      },
    };
  },
};
</script>
